"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Key, MessageCircle } from "lucide-react";
export default function TheHero() {
  const {
    ref: contentRef,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  return <section className="relative min-h-screen w-full overflow-hidden bg-[#002147]">
      {}
      <div className="absolute inset-4 sm:inset-6 md:inset-8 border border-[#d4af37] pointer-events-none" />

      {}
      <div ref={contentRef} className="relative z-10 flex min-h-screen flex-col items-center justify-center px-6 sm:px-8 md:px-12 pt-20 sm:pt-24 md:pt-28 pb-8 sm:pb-10 md:pb-12 text-center !opacity-[1]">
        {}
        <p className="font-[var(--font-montserrat)] uppercase tracking-[4px] leading-[1.35] transition-all duration-[180ms] ease-out translate-y-0 opacity-100 text-[#d4af37] mt-2 mb-4 break-words !font-semibold !text-2xl sm:tracking-[8px] sm:mb-6" style={{
        transitionDelay: "0ms"
      }}>ANCHOR YOUR FUTURE GENERATIONS</p>

        {}
        <h1 className="font-[var(--font-cinzel)] font-bold tracking-[2px] leading-[1.2] transition-all duration-[180ms] ease-out translate-y-0 opacity-100 text-[#FDFDF5] text-[36px] sm:text-[48px] md:text-[64px] px-4 sm:px-6 md:px-8 mb-4 sm:mb-6" style={{
        transitionDelay: "100ms"
      }}>Expedite Your Family Wisdom Legacy</h1>

        {}
        <h3 className="font-[var(--font-cinzel)] italic text-[#d4af37] leading-[1.4] transition-all duration-[180ms] ease-out mt-2 mb-8 translate-y-0 opacity-100 font-medium text-xl !font-sans sm:text-2xl md:text-3xl" style={{
        transitionDelay: "125ms"
      }}>With My 9 Life Pillar Framework</h3>

        {}
        <p className="font-[var(--font-libre-baskerville)] font-light leading-[1.6] transition-all duration-[180ms] ease-out translate-y-0 opacity-100 mb-6 text-[#FDFDF5]/90 !text-xl" style={{
        transitionDelay: "150ms"
      }}>Meticulously designed and curated with love</p>

        {}
        <Button asChild size="lg" className={`transform max-w-full w-full sm:w-auto whitespace-normal text-center break-words px-4 py-3 sm:px-8 sm:py-4 text-sm sm:text-base bg-[hsl(45,65%,52%)] text-[hsl(210,100%,12%)] hover:bg-[hsl(45,65%,48%)] font-[var(--font-montserrat)] font-bold tracking-[2px] shadow-medium transition-all duration-[180ms] ease-out hover:scale-105 hover:shadow-strong ${isVisible ? "translate-y-0 opacity-100" : "translate-y-2.5 opacity-0"}`} style={{
        transitionDelay: "200ms"
      }}>
          <Link to="https://calendly.com/ancelfernandes/30-min-strategy-call" newTab>BOOK  COMPLIMENTARY CONSULTATION CALL</Link>
        </Button>

        {}
        <p className={`flex items-center justify-center gap-2 font-[var(--font-montserrat)] italic text-[#d4af37]/70 text-[14px] sm:text-[15px] leading-[1.5] transition-all duration-[180ms] ease-out mt-[10px] mb-[15px] ${isVisible ? "translate-y-0 opacity-100" : "translate-y-2.5 opacity-0"}`} style={{
        transitionDelay: "225ms"
      }}>
          <Key className="w-4 h-4 text-[#d4af37]/70 shrink-0" />
          <span>
            Includes a private viewing of <strong>The Heritage Experience</strong> and{" "}
            <strong>The Heritage Compendium</strong>.
          </span>
        </p>

        {}
        <Button asChild variant="outline" size="lg" className={`transform max-w-full w-full sm:w-auto whitespace-normal text-center break-words px-4 py-3 sm:px-6 sm:py-3 text-xs sm:text-sm bg-transparent text-[#d4af37] border-[#d4af37] hover:bg-[#d4af37] hover:text-white font-[var(--font-montserrat)] font-bold tracking-[1.5px] shadow-xs transition-all duration-[180ms] ease-out hover:scale-105 pt-[15px] ${isVisible ? "translate-y-0 opacity-100" : "translate-y-2.5 opacity-0"}`} style={{
        transitionDelay: "250ms"
      }}>
          <Link to="https://wa.me/971504585183?text=I%20am%20interested%20in%20learning%20more%20about%20how%20I%20could%20preserve%20my%20family%20wisdom%20legacy." newTab>
            <MessageCircle className="w-4 h-4 sm:w-5 sm:h-5 mr-2" />
            ENQUIRE VIA WHATSAPP
          </Link>
        </Button>
      </div>
    </section>;
}